import Logger from './logger';

class MixtapePlayer extends HTMLElement {
  #NAME = 'MixtapePlayer';
  #abortController;
  #playlists = [];
  #index;
  #IFrameAPI;
  #EmbedController;
  #playbackStarted = false;
  /* #isPlaying = false; */

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    //
    
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
    this.#EmbedController.destroy();
  }

  static get observedAttributes() {
    return ['data-index', 'data-playlists'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    Logger.info(`${this.#NAME} > attributeChangedCallback > name: ${name} > value: ${newValue}`);
    //
    if (name === 'data-index') {
      this.#index = parseInt(newValue);
      if (this.#EmbedController) {
        Logger.info(`${this.#NAME} > EmbedController > loadUri`);
        this.#EmbedController.loadUri(`spotify:playlist:${this.#playlists[this.#index]}`);
        if (this.#playbackStarted) this.#EmbedController.play();
      } else window.onSpotifyIframeApiReady = (IFrameAPI) => {
        Logger.info(`${this.#NAME} > onSpotifyIframeApiReady`);
        //
        const element = this.querySelector('#embed-iframe');
        const options = {
          height: '100%',
          uri: `spotify:playlist:${this.#playlists[this.#index]}`
        };
        const callback = (EmbedController) => {
          Logger.info(`${this.#NAME} > createController > callback`);
          this.#abortController = new AbortController();
          const { signal } = this.#abortController;
          this.#EmbedController = EmbedController;
          this.#EmbedController.addListener('playback_started', () => {
            this.#playbackStarted = true;
          }, { signal } );
        };
        IFrameAPI.createController(element, options, callback);
      };
    } else if (name === 'data-playlists') {
      this.#playlists = JSON.parse(newValue);
    }
  }

}

customElements.define('mixtape-player', MixtapePlayer);